import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Path } from '../_components/Path';
import { apiConstants } from '../_constants';
import { topicService } from '../_services/topic.service';
import { isEnglish } from '../_helpers';
import NotesList from '../Notes/NotesList';
import { TopicList } from './TopicList';
export const Subject = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [isTopic, setIsTopic] = useState(true);
  const [subjectData, setSubjectData] = useState({});
  const [paginationData, setPaginationData] = useState({});
  const [topics, setTopics] = useState([]);
  const [query, setQuery] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 8,
    },
  });
  useEffect(() => {
    if (id) {
      query.subject_id = id;
      setQuery(query);
      getTopicList(1, query);
    }
  }, [id]);

  const getTopicList = (pageNo, queryTemp) => {
    let queryNew = queryTemp ? queryTemp : query;
    queryNew.pageVo = query.pageVo;
    queryNew.pageVo.pageNo = pageNo;
    if (pageNo == 1) {
      setIsLoading(true);
    }
    setQuery(queryNew);
    topicService.topicList(queryNew).then(
      (res) => {
        setSubjectData(res.data.subject);
        setPaginationData({
          page: res?.data?.page,
          pages: res?.data?.pages,
        });
        if (res?.data?.rows?.length) {
          setTopics(res.data.rows);
        }
        setIsLoading(false);
      },
      (err) => {
        setIsLoading(false);

        console.error(err);
      },
    );
  };
  return (
    <div dir={isEnglish(subjectData?.subject_name) ? 'ltr' : 'rtl'}>
      <div className='container'>
        <Path
          pathList={[
            { name: 'Course List', link: 'courselist' },
            {
              name: 'Subject',
              link: `course/${subjectData?.course_id}`,
              id: subjectData?.course_id,
            },
            { name: 'Topics' },
          ]}
        />
        {(!isLoading || !!subjectData?.course_id) && (
          <div
            className={
              'coursedetails ' + (isEnglish(subjectData?.course_name) ? 'ltrtext' : 'rtltext')
            }
            style={{ flexDirection: isEnglish(subjectData?.course_name) ? 'row' : 'row-reverse' }}
          >
            <img
              src={
                subjectData?.subject_image
                  ? apiConstants.imgUrl + subjectData?.subject_image
                  : '/img/course_dummy.png'
              }
              alt=''
              className='courseicon'
            />
            <div className='coursedesc'>
              <div
                className={
                  'coursenamehead ' + (isEnglish(subjectData?.course_name) ? 'ltrtext' : 'rtltext')
                }
              >
                {subjectData?.course_name}
              </div>
              <div
                className={
                  'subdesc ' + (isEnglish(subjectData?.subject_name) ? 'ltrtext' : 'rtltext')
                }
              >
                {subjectData?.subject_name}
              </div>
              <div
                className={
                  'coursedesc d-flex ' +
                  (isEnglish(subjectData?.course_name)
                    ? 'justify-content-start'
                    : 'justify-content-end')
                }
              >
                <div className='descitem'>
                  <img src='/img/book_icon.png' className='desc_icon' />{' '}
                  {subjectData?.count_topicss} Topics
                </div>
                <div className='descitem'>
                  <img src='/img/question_icon.png' className='desc_icon' />{' '}
                  {subjectData?.questionCount} Questions
                </div>
              </div>
            </div>
          </div>
        )}
        <div className='d-flex justify-content-left gap-3 mb-5 mt-5'>
          <div
            className={'switchitemtopic ' + (isTopic ? 'selecteditem' : '')}
            onClick={() => {
              setIsTopic(true);
            }}
          >
            Topics
          </div>
          <div
            className={'switchitemtopic ' + (!isTopic ? 'selecteditem' : '')}
            onClick={() => {
              setIsTopic(false);
            }}
          >
            Notes
          </div>
        </div>

        {isTopic && (
          <TopicList
            topics={topics}
            handlePagination={(pageNo) => getTopicList(pageNo)}
            paginationData={paginationData}
            isLoading={isLoading}
          />
        )}
        {!isTopic && <NotesList subject_id={subjectData?._id} />}
      </div>
    </div>
  );
};
